import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    constructor(public httpClient: HttpClient,
                public googleAnalyticsService: GoogleAnalyticsService,
                public internetConnectionService: InternetConnectionService,
                public errorApiService: ErrorApiService,
                public applicationSettingsHelper: ApplicationSettingsHelper) {
    }

    test: any;

    public getHttp(eventAction: string, eventCategory: string, eventLabel: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel);
        return this.httpClient.get(eventLabel);
    }

    public getHttpObject<T>(eventAction: string, eventCategory: string, eventLabel: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel);
        return this.httpClient.get<T>(eventLabel);
    }

    public putHttp(eventAction: string, eventCategory: string, eventLabel: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel);
        return this.httpClient.put(eventLabel, {});
    }

    public postHttp(eventAction: string, eventCategory: string, eventLabel: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel);
        return this.httpClient.post(eventLabel, {observe: 'response'});
    }

    public postHttpJson(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel + ' {JSON: ' + json + '}');
        return this.httpClient.post(eventLabel, json, {observe: 'response'});
    }

    public postHttpResponseText(eventAction: string, eventCategory: string, eventLabel: string, json: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel + ' {JSON: ' + json + '}');
        return this.httpClient.post(eventLabel, json, {responseType: 'text'});
    }


    public deleteHttp(eventAction: string, eventCategory: string, eventLabel: string) {
        this.eventEmitter(
            eventAction,
            eventCategory,
            eventLabel);
        return this.httpClient.delete(eventLabel, {observe: 'response'});
    }

    eventEmitter(eventAction, eventCategory, eventLabel) {
        this.googleAnalyticsService.eventEmitter(
            eventAction,
            eventCategory,
            this.applicationSettingsHelper.getStoreSelected() + ': ' + eventLabel,
            1);
    }
}
